module.exports = __webpack_public_path__ + "media/auto_data/check-on-a60a962b.png";